import PropTypes from 'prop-types';
import { EditFinancialAdjustment } from 'features/SubmitProjectProposal/pages';
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';
import { Can } from 'components/Can';

function EditFinancialAdjustmentPage({ readOnly }) {
  return (
    <LayoutProvider>
      <Layout>
        <Can do="update" on="financial_adjustment">
          <EditFinancialAdjustment readOnly={readOnly} />
        </Can>
      </Layout>
    </LayoutProvider>
  );
}

EditFinancialAdjustmentPage.propTypes = {
  readOnly: PropTypes.bool,
};

EditFinancialAdjustmentPage.defaultProps = {
  readOnly: false,
};

export default EditFinancialAdjustmentPage;
